"use client";

import { IncidentFilterContextProvider } from "@/features/incidents/incident-list";
export default function Layout({
  children
}: {
  children: any;
}) {
  return <IncidentFilterContextProvider data-sentry-element="IncidentFilterContextProvider" data-sentry-component="Layout" data-sentry-source-file="layout.tsx">{children}</IncidentFilterContextProvider>;
}